module.exports = __webpack_public_path__ + "static/img/4490_phase_function_Paper_Points.de413e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4490_phase_function_Paper_Points.png
// module id = Vrxs
// module chunks = 0